import FileApi from "../api/Files";

export const downloadRawFileFromServer = (file, name) => {
  const url = URL.createObjectURL(new Blob([file]));

  downloadFileFromServerByUrl(url, name);
};

export const downloadFileFromServerByUrl = (url, name) => {
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", name);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const getFilesWithThumbUrls = async (files) => {
  if (!files || !files.length) {
    return [];
  }

  const guids = files.map((file) => file?.guid);
  const promises = guids?.map((guid) => FileApi.getFileByGuid(guid));
  const resFiles = await Promise.allSettled(promises);

  return files
    .map((file, index) => {
      if (!resFiles[index]?.value?.data) return null;

      const thumbUrl = URL.createObjectURL(resFiles[index].value?.data);
      return {
        ...file,
        key: file.guid,
        deleted: false,
        loading: false,
        thumbUrl: thumbUrl,
      };
    })
    .filter((x) => x);
};
